import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "crm:flex crm:flex-col crm:p-4" }
const _hoisted_2 = {
  key: 0,
  class: "crm:inline-block crm:pb-2 crm:border-b crm:mb-4!"
}
const _hoisted_3 = {
  key: 1,
  class: "crm:inline-block crm:pb-2 crm:border-b crm:mb-4!"
}
const _hoisted_4 = { class: "crm:flex crm:justify-between crm:mt-4" }
const _hoisted_5 = { class: "crm:flex crm:flex-col" }
const _hoisted_6 = { class: "crm:flex" }
const _hoisted_7 = {
  key: 1,
  href: "tel:+390444346288"
}

import {inject, reactive, ref, watch} from "vue";
import BasePopover from "../components/BasePopover.vue";
import {customer_support, eye} from '../svg/svgs.js'


export default {
  __name: 'AppPopoverAssistenza',
  props: {
  /**
   * Mainname dell'utente connesso
   * @example 000615
   */
  mainname: {
    type: String,
    default: ''
  },
  /**
   * Nome utente dell'utente connesso
   * nel caso di login via OTP si tratta del'email di accesso
   */
  nomeUtente: {
    type: String,
    default: ''
  }
},
  setup(__props) {

/**
 * @doc
 * Renderizza e gestisce le info necessarie alla richiesta di assistenza.
 * Visualizzato al momento come un popover posizionato nella navbar
 */
const props = __props

/**
 * Se true mostra il numero di telefono dell'assistenza
 * @type {Ref<UnwrapRef<boolean>>}
 */
const isShowAssistenzaTel = ref(false)

const popOver = reactive({
  assistenza: false
})

watch(popOver, (newValue) => {
  if(!newValue.assistenza) {
    isShowAssistenzaTel.value = false;
  }
})

/**
 * @inject {isMobile} recupera il valore true/false se siamo in una visualizzazione mobile oppure no
 */
const isMobile = inject('isMobile')

return (_ctx, _cache) => {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createBlock(BasePopover, {
    value: popOver.assistenza,
    "onUpdate:value": _cache[1] || (_cache[1] = $event => ((popOver.assistenza) = $event)),
    "custom-classes": {link: 'crm:shadow-none!',
  container: _unref(isMobile) ? 'crm:flex crm:flex-col crm:w-[26rem]! crm:left-2': 'crm:flex crm:flex-col crm:w-[26rem]!'}
  }, {
    cta: _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass(["crm:flex crm:justify-center crm:items-center crm:relative", [!_unref(isMobile) ? 'crm:flex-col' : 'crm:left-[-12px]']])
      }, [
        _createVNode(_component_base_icon, {
          icon: _unref(customer_support),
          class: _normalizeClass({'crm:mr-4': _unref(isMobile)})
        }, null, 8 /* PROPS */, ["icon", "class"]),
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(isMobile) ? 'p' : 'small'), { class: "crm:text-black crm:mt-1" }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("Assistenza", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        }))
      ], 2 /* CLASS */)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.mainname !== '000000')
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
              _cache[3] || (_cache[3] = _createTextVNode("Mainname di riferimento: ", -1 /* CACHED */)),
              _createElementVNode("strong", null, _toDisplayString(__props.mainname), 1 /* TEXT */)
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_3, [
              _cache[4] || (_cache[4] = _createTextVNode("Email di accesso: ", -1 /* CACHED */)),
              _createElementVNode("strong", null, _toDisplayString(__props.nomeUtente), 1 /* TEXT */)
            ])),
        _cache[11] || (_cache[11] = _createElementVNode("p", null, [
          _createTextVNode("Il servizio di assistenza clienti è attivo "),
          _createElementVNode("strong", null, "dal lunedì al venerdì"),
          _createTextVNode(", "),
          _createElementVNode("br"),
          _createTextVNode("con orario 8.30-13.00 / 14.00-18.00")
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[8] || (_cache[8] = _createElementVNode("span", null, [
              _createElementVNode("strong", null, "Email: "),
              _createTextVNode(),
              _createElementVNode("a", {
                href: "mailto:crm@polonotarilezucchetti.it",
                title: "contatta crm@polonotarilezucchetti.it",
                class: "crm:text-primary!",
                target: "_blank"
              }, "crm@polonotarilezucchetti.it")
            ], -1 /* CACHED */)),
            _cache[9] || (_cache[9] = _createElementVNode("span", null, [
              _createElementVNode("strong", null, "Email PEC: "),
              _createTextVNode(" zucchettisoftwaregiuridico@gruppozucchetti.it")
            ], -1 /* CACHED */)),
            _createElementVNode("span", _hoisted_6, [
              _cache[7] || (_cache[7] = _createElementVNode("strong", { class: "crm:inline-block crm:mr-1" }, "Telefono: ", -1 /* CACHED */)),
              (!isShowAssistenzaTel.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "crm:flex crm:items-center crm:gray-300 crm:cursor-pointer js-no-click-away",
                    onClick: _cache[0] || (_cache[0] = _withModifiers($event => (isShowAssistenzaTel.value = true), ["prevent"]))
                  }, [
                    _createVNode(_component_base_icon, {
                      icon: _unref(eye),
                      class: "js-no-click-away"
                    }, null, 8 /* PROPS */, ["icon"]),
                    _cache[5] || (_cache[5] = _createTextVNode()),
                    _cache[6] || (_cache[6] = _createElementVNode("small", { class: "crm:inline-block crm:ml-1 js-no-click-away" }, "Mostra telefono", -1 /* CACHED */))
                  ]))
                : _createCommentVNode("v-if", true),
              (isShowAssistenzaTel.value)
                ? (_openBlock(), _createElementBlock("a", _hoisted_7, "0444 346288"))
                : _createCommentVNode("v-if", true)
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("span", null, [
              _createElementVNode("strong", null, "Teleassistenza: "),
              _createTextVNode(),
              _createElementVNode("a", {
                href: "https://download.teamviewer.com/download/TeamViewerQS.exe",
                title: "download TeamViewer",
                class: "crm:text-primary!",
                target: "_blank"
              }, "Download per Windows"),
              _createTextVNode(" / "),
              _createElementVNode("a", {
                href: "https://download.teamviewer.com/download/TeamViewerQS.dmg",
                title: "download TeamViewer",
                class: "crm:text-primary",
                target: "_blank"
              }, "Download per Mac")
            ], -1 /* CACHED */))
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["value", "custom-classes"]))
}
}

}